var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
var SvgDelete = function SvgDelete(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 21 21",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M10.006 20.004A10 10 0 0 1 2.932 2.93 10.004 10.004 0 0 1 17.08 17.078a9.936 9.936 0 0 1-7.074 2.926Zm-8-9.828a8 8 0 1 0 0-.172v.172Zm5.41 3.828-1.41-1.41 2.59-2.59-2.59-2.59 1.41-1.41 2.59 2.59 2.59-2.59 1.41 1.41-2.59 2.59 2.59 2.59-1.409 1.41-2.59-2.59-2.59 2.59h-.002Z",
    fill: "#333"
  })));
};
export default SvgDelete;